import React from "react";

const ButtonGroup = ({
  onIncrement,
  onDecrease,
  decreaseDisabled,
  increaseDisabled,
}) => (
  <div className="upgrade-skill-button ms-3">
    <button className="btn " disabled={decreaseDisabled} onClick={onDecrease}>
      {" "}
      -{" "}
    </button>
    <button
      className="btn ms-2"
      disabled={increaseDisabled}
      onClick={onIncrement}
    >
      {" "}
      +{" "}
    </button>
  </div>
);

export default ButtonGroup;
